import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import BlogIndex from "@/pages/BlogIndex";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/blog/")({
  head: () => ({
    meta: [
      { title: "Sports Betting Blog: Previews & Insights | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["blog"] }).meta },
      { name: "description", content: "Guides, analysis and insights on sports intelligence, value betting, and how AI predicts match outcomes — from the Statlign team." },
      { property: "og:title", content: "Sports Betting Blog: Previews & Insights | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Guides, analysis and insights on sports intelligence, value betting, and how AI predicts match outcomes — from the Statlign team." },
      { name: "twitter:title", content: "Sports Betting Blog: Previews & Insights | Statlign" },
      { name: "twitter:description", content: "Guides, analysis and insights on sports intelligence, value betting, and how AI predicts match outcomes — from the Statlign team." },
    ],
  }),
  component: () => (
    <MainLayout>
      <BlogIndex />
    </MainLayout>
  ),
});
